import type { JSX } from "react";
import { useI18n } from "../../i18n";
import { useOnlineStatus } from "../../hooks/useOnlineStatus";
import { useSyncStatus } from "../../hooks/useSyncStatus";

export type OfflineBannerVariant = "app" | "auth";

export interface OfflineBannerProps {
  variant?: OfflineBannerVariant;
}

export function OfflineBanner({ variant = "app" }: OfflineBannerProps): JSX.Element | null {
  const { t } = useI18n();
  const online = useOnlineStatus();
  const { status } = useSyncStatus(undefined, 5000);

  const show = !online || status === "offline";
  if (!show) return null;

  const body =
    variant === "auth"
      ? t("status.offlineAuthBody")
      : t("status.offlineBody");

  return (
    <div
      data-testid="offline-banner"
      role="status"
      className="border-b border-[var(--color-rust)] bg-[var(--color-rust)]/10 px-4 py-3"
    >
      <p className="font-subhead text-sm uppercase tracking-[0.06em] text-[var(--color-blood)]">
        {t("status.offlineTitle")}
      </p>
      <p className="mt-1 font-sans text-sm text-[var(--color-ink)]">{body}</p>
    </div>
  );
}
